import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import classNames from 'classnames';
import './styles.scss';
import React, { useRef, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Translate } from '../index';
import CarouselFooter from '../CarouselFooter';
import { NewsItem } from '../../../view/dashboard/store/dashboardSlice';

export interface NewsProps {
  data: NewsItem[];
  newsWidth: string | number;
  styles?: React.CSSProperties;
  classname?: string;
  duration?: number;
}

function News({ data, classname, styles }: NewsProps) {
  const { t } = useTranslation();
  const classes = classNames('news-carousel', classname);
  const sliderRef = useRef<Slider | null>(null);
  const [currentSlide, setCurrentSlide] = useState<number>(1);

  const totalDocuments = data?.length || 0;

  const numberToShow = currentSlide;

  const next = () => {
    sliderRef.current?.slickNext();
  };

  const previous = () => {
    sliderRef.current?.slickPrev();
  };

  const handleAfterChange = (current: number) => {
    setCurrentSlide(current + 1);
  };

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    height: 10,
    autoplay: true,
    afterChange: handleAfterChange,
  };

  const isResultsEmpty = data.length <= 1;

  return (
    <div data-testid="news-component" style={styles} className={classes}>
      <div className="py-[2rem] px-[2.5rem]">
        <h1 className="text-[#767676] text-[14px] dark:text-gray-200">
          {t('news.title')}
        </h1>
        <div className="pt-6 pb-6">
          <Slider ref={sliderRef} {...settings}>
            {data.map((item: any) => (
              <div className="items" key={item.id}>
                <Translate en={item.content_en} bn={item.content_bn} />
                &nbsp;
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <CarouselFooter
        isEmpty={isResultsEmpty}
        totalItem={totalDocuments}
        currentItem={numberToShow}
        previous={previous}
        next={next}
      />
    </div>
  );
}

export default memo(News);
